import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-vids-skeleton',
  templateUrl: './vids-skeleton.component.html',
  styleUrls: ['./vids-skeleton.component.css']
})
export class VidsSkeletonComponent implements OnInit {
  @Input() count: number = 6; // Number of skeleton items to show
  placeholders: any[] = [];

  ngOnInit() {
    this.placeholders = Array(this.count).fill(null); // Create an array of placeholders
  }
}
